module.exports = __webpack_public_path__ + "static/img/timeline-evasive.1a80f2b.png";